import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyAt9p3BGKBeNSF26npq2QELA3GIBMToScU",
  authDomain: "raktdaan-7a169.firebaseapp.com",
  databaseURL: "https://raktdaan-7a169-default-rtdb.firebaseio.com",
  projectId: "raktdaan-7a169",
  storageBucket: "raktdaan-7a169.appspot.com",
  messagingSenderId: "116685109840",
  appId: "1:116685109840:web:e1fa668c364e4c53fd6f55"

};

const app = initializeApp(firebaseConfig);
const textdb = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const database = getDatabase(app);
auth.settings.appVerificationDisabledForTesting = true;

export { textdb, storage, auth, app,database };
export default firebaseConfig;






  // apiKey: "AIzaSyCS3Vw3Nxgbo4alqJljKHiPk1imN0o_0Fs",
  // authDomain: "textphoto-48149.firebaseapp.com",
  // projectId: "textphoto-48149",
  // storageBucket: "textphoto-48149.appspot.com",
  // messagingSenderId: "483201101560",
  // appId: "1:483201101560:web:022987b52930ea15b6950d",



//   import { initializeApp } from "firebase/app";
// import { getDatabase } from "firebase/database";
// import { getStorage } from "firebase/storage";
// import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyAt9p3BGKBeNSF26npq2QELA3GIBMToScU",
//   authDomain: "raktdaan-7a169.firebaseapp.com",
//   databaseURL: "https://raktdaan-7a169-default-rtdb.firebaseio.com",
//   projectId: "raktdaan-7a169",
//   storageBucket: "raktdaan-7a169.appspot.com",
//   messagingSenderId: "116685109840",
//   appId: "1:116685109840:web:e1fa668c364e4c53fd6f55"
// };

// const app = initializeApp(firebaseConfig);
// const textdb = getDatabase(app);
// const storage = getStorage(app);
// const auth = getAuth(app);

// auth.settings.appVerificationDisabledForTesting = true;

// export { textdb, storage, auth, app, };
// export default firebaseConfig;
